// src/components/TimerGuard.tsx
import { useEffect, type FC } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTimer } from '../contextes/useTimer';

const TimerGuard: FC = () => {
    // Récupère le temps restant du contexte Timer
    const { time } = useTimer();
    const navigate = useNavigate();
    const location = useLocation();

    // Récupère le numéro de mission depuis les paramètres d'URL
    const { missionNumber } = useParams<{ missionNumber: string }>();

    useEffect(() => {
        // si le temps est fini et qu'on n'est pas déjà sur la page de fin
        if (time === 0 && !location.pathname.includes('/endgame')) {
            if (missionNumber) {
                navigate(`/mission/${missionNumber}/endgame`, {
                    replace: true,
                    state: { hasWon: false }, // on passera ça à la page
                });
            }
        }
    }, [time, location.pathname, missionNumber, navigate]);

    return null; // ne rend rien à l'écran
};

export default TimerGuard;
